import * as svg from "../../../assets/people-outline-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const PeopleOutlineIcon = iconBuilder(svg, "PeopleOutlineIcon", "0 0 21 21");
